module.exports = __webpack_public_path__ + "img/gmLogo.217cae04.png";